import { Link } from 'react-router';
import { cx } from './styles';

export const TEST_DISCLAIMER =
  'Oefy B.V. is onafhankelijk en niet verbonden aan of gesponsord door Cito B.V., Bureau ICE, A-VISION, of andere aanbieders van doorstroomtoetsen. Alle merknamen en toetsen zijn eigendom van hun respectieve rechthebbenden. Onze oefenboeken zijn ontwikkeld door ervaren docenten en sluiten aan op doelen van het basisonderwijs.';

const YEAR = new Date().getFullYear();

const linkClass =
  'rounded font-semibold text-slate-700 underline-offset-4 transition hover:text-brand-700 hover:underline pointer-coarse:py-1';

interface SiteFooterProps {
  readonly disclaimer?: boolean;
  readonly className?: string;
}

export function SiteFooter({ disclaimer = false, className }: SiteFooterProps) {
  return (
    <footer className={cx('space-y-4 text-xs leading-relaxed text-slate-600', className)}>
      {disclaimer ? (
        <p id="toelichting" className="max-w-3xl scroll-mt-6">
          <span aria-hidden="true">* </span>
          {TEST_DISCLAIMER}
        </p>
      ) : null}
      <div className="flex flex-wrap items-center justify-between gap-x-6 gap-y-2">
        <nav aria-label="Voorwaarden en privacy">
          <ul className="flex flex-wrap gap-x-5 gap-y-1">
            <li>
              <Link to="/algemene-voorwaarden" className={linkClass}>
                Algemene voorwaarden
              </Link>
            </li>
            <li>
              <Link to="/privacyverklaring" className={linkClass}>
                Privacyverklaring
              </Link>
            </li>
          </ul>
        </nav>
        <span>© {YEAR} Oefy B.V.</span>
      </div>
    </footer>
  );
}
